import webApi, { baseURL } from "../../WebApi/WebApi";

export const getInvoiceBusinessUnitList = async (data) => {
  return await webApi.get(`/customer/invoice/list-business-unit`, {});
};

export const getInvoiceSupplierList = async (data) => {
  return await webApi.get(`/customer/invoice/list-suppliers`, {});
};

//past order listing
export const getAllPastOrderDetailslist = async (
  business,
  supplier,
  data,
  from,
  to,
  orderStatus
) => {
  return await webApi.post(
    `/customer/past-order/list-past-order?searchKeyword=${data ? data : ""}`,
    {
      fromDate: from ? from : "",
      toDate: to ? to : "",
      businessUnitName: business ? [...new Set(business.map(Number))] : [],
      suppliersName: supplier ? supplier.flat() : [],
      orderStatus: orderStatus ? [orderStatus] : [],
    }
  );
};

export const getPastOrderById = async (data, invoiceId) => {
  console.log(data, "datata");
  return await webApi.post(`/customer/past-order/get-past-order-by-id`, {
    pastOrderId: Number(data),
    userInvoiceId: Number(invoiceId),
  });
};
export const getPurchaseOrderById = async (data) => {
  return await webApi.post(`/customer/purchase-order/past-order-details`, {
    purchaseOrderId: Number(data),
  });
};

export const getAnswer = async (QCAnser, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/past-order/add-anser`, QCAnser);
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};
export const getAnswerPurchase = async (QCAnser, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(
      `/customer/purchase-order/add-answer`,
      QCAnser
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

//delete past order

export const deletePastOrder = async (pastOrderId, onSuccess, onFailure) => {
  try {
    const res = await webApi.post(`/customer/past-order/delete-past-order`, {
      pastOrderId: pastOrderId,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const getEditPurchaseOrder = async (
  poId,
  businessName,
  comments,
  invoiceId,
  orderStatus,
  GhgKeyId,
  // GlKeyId,
  departmentId,
  startDate,
  emissionData,
  wasteData,
  onSuccess,
  onFailure
) => {
  console.log(emissionData, "emissionData");
  try {
    const res = await webApi.post(
      `/customer/purchase-order/edit-purchase-order`,
      {
        purchaseOrderId: Number(poId),
        businessUnitId: businessName ? Number(businessName) : null,
        comments: comments,
        userInvoiceId: invoiceId,
        orderStatus: orderStatus,
        GhgKeyId: GhgKeyId ? JSON.parse(GhgKeyId)?.id : null,
        // GlKeyId: GlKeyId ? JSON.parse(GlKeyId)?.id : null,
        departmentId: departmentId ? Number(departmentId) : null,
        deliveryDateTime: startDate,
        transportEmission: emissionData,
        wastePackageMaterial: wasteData,
      }
    );
    if (res.status === 200) {
      const r = res.data;
      console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};
export const getEditPastOrder = async (
  poId,
  businessName,
  comments,
  invoiceId,
  orderStatus,
  GhgKeyId,
  GlKeyId,
  departmentId,
  startDate,
  emissionData,
  wasteData,
  onSuccess,
  onFailure
) => {
  console.log(GhgKeyId, "GhgKeyId");
  try {
    const res = await webApi.post(`/customer/past-order/edit-past-order`, {
      pastOrderId: Number(poId),
      businessUnitId: businessName ? Number(businessName) : null,
      comments: comments,
      userInvoiceId: invoiceId,
      orderStatus: orderStatus,
      GhgKeyId: GhgKeyId ? JSON.parse(GhgKeyId)?.id : null,
      GlKeyId: GlKeyId ? JSON.parse(GlKeyId)?.id : null,
      departmentId: Number(departmentId),
      deliveryDateTime: startDate,
      transportEmission: emissionData,
      wastePackageMaterial: wasteData,
    });
    console.log("96332541", res);
    if (res?.data?.status === 200) {
      const r = res.data;
      console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const getActivePastOrder = async (
  module,
  id,
  isactive,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/common/is-active`, {
      module: module,
      id: id,
      isActive: isactive,
    });
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const updateReceiveQuantity = async (
  userInvoiceId,
  ItemId,
  receivedQuantity,
  pastOrderId,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(`/customer/past-order/add-receive-quantity`, {
      userInvoiceId,
      ItemId,
      receivedQuantity,
      pastOrderId,
    });
    if (res.status === 200) {
      const r = res.data;
      console.log(r, "rerere");
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const getAccountingInformation = async (
  pastOrderId,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(
      `/customer/past-order/get-accounting-information`,
      {
        pastOrderId,
      }
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};

export const updateAccountingInformation = async (
  data,
  onSuccess,
  onFailure
) => {
  try {
    const res = await webApi.post(
      `/customer/past-order/update-accounting-information`,
      data
    );
    if (res.status === 200) {
      const r = res.data;
      return onSuccess(r);
    } else {
      onFailure("Something Wrong! Please Try again later" + res.data);
    }
  } catch (error) {
    console.log("fdgdf");
  }
};
